import { all } from 'redux-saga/effects';
import organizationSaga from './organization';
import organizationDetailSaga from './organizationDetail';
import profileUpdateSaga from './profileUpdate';

export default function* organizationModuleSaga() {
  yield all([organizationSaga(), organizationDetailSaga(), profileUpdateSaga()]);
}
